export default {
      id: "chevron-usage",
      viewBox: "0 0 26 12",
      url: "/assets/" + "icons.svg#chevron",
      toString: function () {
        return this.url;
      }
    }